<template>
  <v-card flat class="checkout-resumen">
    <v-row>
      <v-col cols="12" md="4">
        <div v-if="usuario" class="resumen-col">
          <h3 class="resumen-titulo">Datos personales</h3>
          <div class="resumen-item">
            <v-icon small color="primary">mdi-account</v-icon>
            <span>{{ usuario.nombre }}</span>
          </div>
          <template v-if="formaEntrega === 1">
            <div class="resumen-item">
              <v-icon small color="primary">mdi-map-marker</v-icon>
              <span>{{ `${usuario.direccion} ${usuario.pisoDpto}` }}</span>
            </div>
            <a
              v-if="usuario.googleMapsUrl"
              :href="usuario.googleMapsUrl"
              target="_blank"
              class="resumen-link">
              <v-icon x-small color="primary">mdi-map</v-icon>
              Ver en Google Maps
            </a>
          </template>
          <div class="resumen-item">
            <v-icon small color="primary">mdi-cellphone</v-icon>
            <span>{{ usuario.celular }}</span>
          </div>
        </div>
      </v-col>
      <v-col cols="12" md="4">
        <div class="resumen-col">
          <h3 class="resumen-titulo">Forma de entrega</h3>
          <div class="resumen-item">
            <v-icon small color="primary">{{ iconoFormaEntrega }}</v-icon>
            <span>{{ formaEntregaNombre }}</span>
          </div>
          <div
            v-if="formaEntrega === 2 && clientData && clientData.Direccion"
            class="resumen-item resumen-item--secundario">
            <v-icon x-small color="primary">mdi-map-marker</v-icon>
            <span>{{ clientData.Direccion }}</span>
          </div>
          <div v-if="horarioDistinto && horaProgramada" class="resumen-item">
            <v-icon small color="primary">mdi-clock-outline</v-icon>
            <span>{{ textoHorarioProgramado }}</span>
          </div>
          <div v-else class="resumen-item resumen-item--secundario">
            <v-icon x-small color="primary">mdi-lightning-bolt</v-icon>
            <span>Lo antes posible</span>
          </div>
          <h3 class="resumen-titulo resumen-titulo--grupo">Forma de pago</h3>
          <div class="resumen-item">
            <v-icon small color="primary">{{ iconoFormaPago }}</v-icon>
            <span>{{ formaPagoNombre }}</span>
          </div>
        </div>
      </v-col>
      <v-col cols="12" md="4">
        <div class="resumen-col">
          <h3 class="resumen-titulo">Importes</h3>
          <div class="resumen-importe">
            <span>Subtotal</span>
            <span>${{ total }}</span>
          </div>
          <template v-if="getDescuentos.hayDescuentos.length > 0">
            <div
              v-for="(detalle, index) in detalleDescuentos"
              :key="`descuento_${index}`"
              class="resumen-descuento">
              <span>
                <strong>{{ detalle.tipo }}:</strong> {{ detalle.descripcion }}
              </span>
              <span>-${{ detalle.monto.toFixed(2) }}</span>
            </div>
            <div class="resumen-importe resumen-importe--descuento">
              <span>Total descuentos</span>
              <span>-${{ totalDescuento.toFixed(2) }}</span>
            </div>
          </template>
          <div v-if="porcentajeAumento > 0" class="resumen-importe">
            <span>Recargo</span>
            <span>{{ porcentajeAumento }}%</span>
          </div>
          <div v-if="mostrarSubtotalCostoEnvio" class="resumen-importe">
            <span>Costo de envío</span>
            <span>${{ clientData && clientData.UsarDeliveryPorZonas ? costoEnvioPorZona : (clientData && clientData.CostoEnvio) || 0 }}</span>
          </div>
          <div class="resumen-importe resumen-importe--total">
            <span>Total</span>
            <span>${{ totalCompra }}</span>
          </div>
        </div>
      </v-col>
    </v-row>
    <v-row no-gutters>
      <v-col cols="12">
        <v-textarea v-model="observaciones" outlined
        label="Para observaciones del pedido"
        single-line></v-textarea>
      </v-col>
      <v-col cols="12" v-if="aplicarCupon">
        <v-btn text color="primary" @click.prevent.stop="openCuponDialog = true" :disabled="getDescuentos.hayDescuentos.filter(d => d === 'Cupon').length > 0">
          <v-icon>mdi-ticket-percent</v-icon>
          CODIGO DE PROMO
        </v-btn>
        <cupon-dialog :open.sync="openCuponDialog" v-if="openCuponDialog"></cupon-dialog>
      </v-col>
      <v-col cols="12" v-if="formaPago === 1">
        <v-switch v-model="eligirConCuantoPaga" label="Elegir con cuanto pago"></v-switch>
        <elegir-importe-contado
          v-if="eligirConCuantoPaga"
          :total="calcularTotal"
          @importe-elegido="conCuantoPago = $event"
          @importe-invalido="$emit('importeMinimoChange', $event)">
        </elegir-importe-contado>
<!--         <v-select v-show="eligirConCuantoPaga" v-model="conCuantoPago" :items="denominaciones"></v-select> -->
      </v-col>
      <v-col cols="12">
        <div class="resumen-detalle">
          <h3 class="resumen-titulo">Detalle</h3>
          <cart-details :readonly="true"></cart-details>
          <cart-suggestions class="mt-2"></cart-suggestions>
        </div>
      </v-col>
    </v-row>

    <mercado-pago-brick
      v-if="mpBrickOpen && mpPublicKey && mpPreferenceId"
      v-model="mpBrickOpen"
      :public-key="mpPublicKey"
      :amount="mpAmount"
      :pedido-id="mpPedidoId"
      :preference-id="mpPreferenceId"
      :payer-email="mpPayerEmail"
      description="Pedido por Clickaway"
      @paid="onMpPaid"
      @pending="onMpPending"
      @cancel="onMpCancel"
    />
  </v-card>
</template>
<script>
import CartDetails from '@/components/dialogs/CartDetails.vue'
import IconosEnum from '@/helpers/iconos.js'
import { mapGetters, mapActions, mapState } from 'vuex'
import { bus } from '@/helpers/bus.js'
import mapToPedidoDeta from '@/helpers/mapToPedidoDeta.js'
import ElegirImporteContado from './ElegirImporteContado.vue'
import descuentoHelper from '@/helpers/descuentosHelper.js'
import CuponDialog from '../dialogs/CuponDialog.vue'
import MercadoPagoBrick from './MercadoPagoBrick.vue'
import { todayAtHHmmLocalIso } from '@/helpers/horarioProgramado.js'

export default {
  name: 'Resumen',
  components: {
    CartDetails,
    // Import diferido: CartSuggestions usa axios, y axios importa el router,
    // que a su vez carga este checkout. Un import estático llega undefined.
    CartSuggestions: () => import('@/components/dialogs/CartSuggestions.vue'),
    ElegirImporteContado,
    CuponDialog,
    MercadoPagoBrick
  },
  mounted () {
    bus.$on('nuevoCostoEnvio', (data) => {
      this.costoEnvioPorZona = data
    })
    bus.$on('onFormaPagoChangedBus', (data) => {
      const { PorcentajeAumento } = this.clientData && this.clientData.formasPago ? this.clientData.formasPago.filter(e => e.id === data)[0] : {}
      this.formaPago = data
      if (PorcentajeAumento) {
        this.porcentajeAumento += PorcentajeAumento
      } else {
        this.porcentajeAumento = null
      }
    })
    bus.$on('onFormaEntregaChangedBus', (data) => {
      this.formaEntrega = data
    })
    bus.$on('onDataChangedBus', (data) => {
      this.usuario = data
    })
    bus.$on('compraConfirmada', async () => {
      // agrego esta bandera por las dudas
      // if (this.comprando) return
      // this.comprando = true
      await this.comprar()
    })
    this.aplicarCupon = descuentoHelper.existeCupon()
  },
  beforeDestroy () {
    bus.$off('nuevoCostoEnvio')
    bus.$off('onFormaPagoChangedBus')
    bus.$off('onFormaEntregaChangedBus')
    bus.$off('onDataChangedBus')
    bus.$off('compraConfirmada')
  },
  computed: {
    ...mapState('Cuenta', ['me']),
    ...mapState('Checkout', ['horarioDistinto', 'horaProgramada']),
    ...mapGetters({
      clientData: 'App/data',
      total: 'Carrito/getTotal',
      items: 'Carrito/getItems',
      whatsAppOrder: 'Carrito/getWppOrder',
      isLoggedIn: 'Cuenta/isLoggedIn'
    }),
    textoHorarioProgramado () {
      if (!this.horaProgramada) return ''
      const label = this.formaEntrega === 2 ? 'Retiro' : 'Entrega'
      return `${label} hoy a las ${this.horaProgramada}`
    },
    denominaciones () {
      const d = [150, 200, 500, 1000]
      return d
    },
    mostrarSubtotalCostoEnvio () {
      return (this.clientData && this.clientData.UsarDeliveryPorZonas) || (this.clientData && this.clientData.CostoEnvio > 0) && this.formaEntrega !== 2
    },
    totalCompra () {
      let tmpTotal = this.total
      if (this.totalDescuento > 0) {
        tmpTotal -= this.totalDescuento
      }
      if (this.clientData && this.formaEntrega === 1) {
        if (this.clientData && this.clientData.UsarDeliveryPorZonas) {
          tmpTotal = tmpTotal + this.costoEnvioPorZona
        } else if (this.clientData && this.clientData.CostoEnvio > 0) {
          tmpTotal = tmpTotal + this.clientData.CostoEnvio
        }
      }
      if (this.clientData && this.porcentajeAumento > 0) {
        tmpTotal += (tmpTotal * (this.porcentajeAumento / 100))
      }
      return tmpTotal.toFixed(2)
    },
    iconoFormaEntrega () {
      if (this.formaEntrega === 1) return IconosEnum.Delivery
      return IconosEnum.RetiraSucursal
    },
    iconoFormaPago () {
      if (this.formaPago === 2) return IconosEnum.PagoTarjeta
      return IconosEnum.PagoEfectivo
    },
    formaEntregaNombre () {
      if (!this.clientData || !this.clientData.formasEnvio) return ''
      const match = this.clientData.formasEnvio.find(e => e.id === this.formaEntrega)
      return match ? match.name : ''
    },
    formaPagoNombre () {
      if (!this.clientData || !this.clientData.formasPago) return ''
      const match = this.clientData.formasPago.find(e => e.id === this.formaPago)
      return match ? match.name : ''
    },
    getDescuentos () {
      return descuentoHelper.calcularDescuentos(this.formaPago, this.total)
    },
    calcularTotal () {
      return parseFloat(this.totalCompra)
    }
  },
  methods: {
    ...mapActions('App', ['savePedido', 'savePreferenciaMercadoPago']),
    ...mapActions('Cuenta', ['saveMe', 'saveCustomerAddress', 'updateCustomerAddress']),
    onMpPaid ({ pedidoId }) {
      this.comprando = false
      this.mpBrickOpen = false
      this.$emit('pedido-grabado', String(pedidoId))
    },
    onMpPending ({ pedidoId }) {
      this.comprando = false
      this.mpBrickOpen = false
      this.$emit('pedido-grabado', String(pedidoId))
    },
    onMpCancel () {
      // Pedido ya creado en pendiente de pago; ir al detalle
      this.comprando = false
      this.mpBrickOpen = false
      if (this.mpPedidoId) {
        this.$emit('pedido-grabado', String(this.mpPedidoId))
      } else {
        this.$emit('compra-cancelada', {
          success: false,
          message: 'Pago cancelado. El pedido quedó pendiente de pago.'
        })
      }
    },
    totalConCostoEnvio () {
      let tmpTotal = this.total
      if (this.clientData && this.formaEntrega === 1) {
        if (this.clientData && this.clientData.UsarDeliveryPorZonas) {
          tmpTotal = tmpTotal + this.costoEnvioPorZona
        } else if (this.clientData && this.clientData.CostoEnvio > 0) {
          tmpTotal = tmpTotal + this.clientData.CostoEnvio
        }
      }
      if (this.clientData && this.porcentajeAumento > 0) {
        tmpTotal += (tmpTotal * (this.porcentajeAumento / 100))
      }
      return tmpTotal
    },
    totalSinCostoEnvio () {
      let tmpTotal = this.total
      if (this.clientData && this.porcentajeAumento > 0) {
        tmpTotal += (tmpTotal * (this.porcentajeAumento / 100))
      }
      return tmpTotal
    },
    async comprar () {
      if (this.horarioDistinto && !this.horaProgramada) {
        this.$emit('compra-cancelada', {
          success: false,
          message: 'Elegí un horario para el pedido o desactivá la programación.'
        })
        return
      }
      if (this.eligirConCuantoPaga) {
        const montoAPagar = parseFloat(this.totalCompra)
        const montoIngresado = parseFloat(this.conCuantoPago)
        if (isNaN(montoIngresado) || montoIngresado < montoAPagar) {
          this.$emit('compra-cancelada', {
            success: false,
            message: `El importe con el que pagás debe ser mayor o igual a $${Number(montoAPagar).toFixed(2)}`
          })
          return
        }
      }
      const total = this.totalSinCostoEnvio()
      const pedidoDTO = {
        telefono: this.usuario.celular,
        nombre: this.usuario.nombre,
        direccion: `${this.usuario.direccion} ${this.usuario.pisoDpto}`,
        googleMapsUrl: this.usuario.googleMapsUrl || null,
        origen: 1,
        estado: this.formaPago === 2 ? 8 : 1,
        total,
        costoEnvio: this.formaEntrega === 1 ? this.costoEnvioPorZona && this.costoEnvioPorZona > 0 ? this.costoEnvioPorZona : (this.clientData && this.clientData.CostoEnvio) || 0 : 0,
        codCliente: this.$clientCode(),
        observaciones: this.observaciones,
        formaPago: this.formaPago,
        formaEntrega: this.formaEntrega,
        conCuantoPaga: this.conCuantoPago,
        pedidosYaDescuento: this.totalDescuento,
        detalleDescuentos: JSON.stringify(this.detalleDescuentos), // Guardar detalle de descuentos
        detalle: []
      }
      if (this.isLoggedIn && this.me && this.me.CliCliente_id) {
        pedidoDTO.cliClienteId = this.me.CliCliente_id
      }
      if (this.horarioDistinto && this.horaProgramada) {
        // String local sin Z: evita UTC (+3h) al serializar Date en JSON
        const dt = todayAtHHmmLocalIso(this.horaProgramada)
        pedidoDTO.esPrePedido = true
        if (this.formaEntrega === 2) {
          pedidoDTO.tiempoRetira = dt
        } else if (this.formaEntrega === 1) {
          pedidoDTO.tiempoEntrega = dt
        } else {
          // Otras formas: guardar en TiempoEntrega por defecto
          pedidoDTO.tiempoEntrega = dt
        }
      }
      this.items.forEach(element => {
        pedidoDTO.detalle.push(mapToPedidoDeta(element))
        if (element.esCombinado || element.esEstatico) {
          element.productos.forEach((p) => {
            pedidoDTO.detalle.push(mapToPedidoDeta(p))
          })
        }
      })

      let response
      try {
        response = await this.savePedido(pedidoDTO)
        if (response.status !== 200 || response.data.success === false) {
          this.$emit('compra-cancelada', response.data || {
            success: false,
            message: 'No se pudo completar el pedido. Revisá el stock e intentá de nuevo.'
          })
          return
        }
      } catch (err) {
        const msg = (err && err.response && err.response.data && err.response.data.message)
          ? err.response.data.message
          : (err && err.message) ? err.message : 'No se pudo completar el pedido.'
        this.$emit('compra-cancelada', { success: false, message: msg })
        return
      }

      const userInfo = {
        name: this.$CryptoJS.AES.encrypt(
          this.usuario.nombre,
          process.env.VUE_APP_SECRET_PHRASE
        ).toString(),
        obs: this.$CryptoJS.AES.encrypt(
          this.observaciones,
          process.env.VUE_APP_SECRET_PHRASE
        ).toString(),
        phone: this.$CryptoJS.AES.encrypt(
          this.usuario.celular,
          process.env.VUE_APP_SECRET_PHRASE
        ).toString(),
        address: this.$CryptoJS.AES.encrypt(
          this.usuario.direccion,
          process.env.VUE_APP_SECRET_PHRASE
        ).toString()
      }
      this.$cookies.set('info', userInfo)

      // Persistencia por cuenta: nombre/teléfono + dirección principal en tabla de direcciones.
      if (this.isLoggedIn) {
        try {
          const clientCode = this.$clientCode()
          const updated = await this.saveMe({
            clientCode,
            payload: {
              ApellidoNombre: this.usuario.nombre,
              Telefono: this.usuario.celular
            }
          })
          if (this.formaEntrega !== 2 && this.usuario.direccion) {
            const me = updated || this.$store.state.Cuenta.me
            const principal = me && me.Addresses
              ? me.Addresses.find(a => a.EsPrincipal)
              : null
            const addrPayload = {
              Alias: principal && principal.Alias ? principal.Alias : 'Principal',
              DireccionTexto: `${this.usuario.direccion} ${this.usuario.pisoDpto || ''}`.trim(),
              Lat: this.usuario.lat != null && this.usuario.lat !== '' ? Number(this.usuario.lat) : null,
              Lng: this.usuario.lng != null && this.usuario.lng !== '' ? Number(this.usuario.lng) : null,
              GoogleMapsUrl: this.usuario.googleMapsUrl || null,
              EsPrincipal: true
            }
            if (principal && principal.CliClienteDir_id) {
              await this.updateCustomerAddress({
                clientCode,
                id: principal.CliClienteDir_id,
                payload: addrPayload
              })
            } else {
              await this.saveCustomerAddress({ clientCode, payload: addrPayload })
            }
          }
        } catch (e) {
          // No bloquear la compra si falla el guardado
        }
      }
      // mercado-pago: Payment Brick (Checkout API)
      if (this.formaPago === 2) {
        const pedidoId = parseInt(response.data.message.trim())
        localStorage.setItem('mis-pedidos', JSON.stringify([pedidoId]))

        const formaMp = this.clientData && this.clientData.formasPago
          ? this.clientData.formasPago.find(e => e.id === this.formaPago)
          : null
        const publicKey = formaMp && formaMp.credentials ? formaMp.credentials.PublicKey : null
        if (!publicKey) {
          this.$emit('compra-cancelada', {
            success: false,
            message: 'Mercado Pago no está configurado correctamente (Public Key).'
          })
          return
        }

        let preferenceId = null
        try {
          const pref = await this.savePreferenciaMercadoPago({
            id: pedidoId,
            total: this.calcularTotal
          })
          const body = pref && pref.data ? pref.data : null
          preferenceId = body && (body.Id || body.id)
        } catch (e) {
          preferenceId = null
        }
        if (!preferenceId || preferenceId === '-1') {
          this.comprando = false
          this.$emit('compra-cancelada', {
            success: false,
            message: 'No se pudo preparar el pago con Mercado Pago. El pedido quedó pendiente de pago.'
          })
          return
        }

        this.mpPedidoId = pedidoId
        this.mpAmount = this.calcularTotal
        this.mpPublicKey = publicKey
        this.mpPreferenceId = preferenceId
        this.mpPayerEmail = (this.usuario && this.usuario.email) || ''
        this.mpBrickOpen = true
        this.comprando = false
      } else if (this.clientData && this.clientData.EnviarVentasPorWhatsapp) {
        const formaPago = this.clientData && this.clientData.formasPago ? this.clientData.formasPago.filter(e => e.id === this.formaPago) : []
        const formaEnvio = this.clientData && this.clientData.formasEnvio ? this.clientData.formasEnvio.filter(e => e.id === this.formaEntrega) : []
        const fechaHora = new Date().toLocaleString('es-AR', {
          year: 'numeric',
          month: '2-digit',
          day: '2-digit',
          hour: '2-digit',
          minute: '2-digit'
        })

        let text = '🛒 *NUEVO PEDIDO*\n'
        text += `📅 Fecha: ${fechaHora}\n`
        text += `🔢 Pedido N°: ${response.data.message.trim()}\n\n`

        text += '📋 *DETALLE DEL PEDIDO:*\n'
        text += this.whatsAppOrder
        text += '\n'

        text += '👤 *DATOS DEL CLIENTE:*\n'
        text += `• Nombre: ${this.usuario.nombre}\n`
        text += `• Teléfono: ${this.usuario.celular}\n`
        text += `• Dirección: ${this.usuario.direccion} ${this.usuario.pisoDpto}\n`

        // Agregar link de Google Maps si está disponible
        if (this.usuario.googleMapsUrl) {
          text += `• 📍 Ubicación: ${this.usuario.googleMapsUrl}\n`
        }

        if (this.observaciones) {
          text += `• Observaciones: ${this.observaciones}\n`
        }
        text += '\n'

        text += '💰 *RESUMEN DE PAGO:*\n'
        text += `• Subtotal: $${total}\n`

        if (this.formaEntrega === 1) {
          const costoEnvio = this.costoEnvioPorZona && this.costoEnvioPorZona > 0 ? this.costoEnvioPorZona : (this.clientData && this.clientData.CostoEnvio) || 0
          text += `• Costo de envío: $${costoEnvio}\n`
        }

        if (this.totalDescuento > 0) {
          text += '• Descuentos:\n'
          this.detalleDescuentos.forEach(d => {
            text += `  - ${d.tipo}: ${d.descripcion} -$${d.monto.toFixed(2)}\n`
          })
          text += `  *Total descuentos: -$${this.totalDescuento.toFixed(2)}*\n`
        }

        text += `• *TOTAL: $${this.totalConCostoEnvio()}*\n\n`

        text += '💳 *FORMA DE PAGO:*\n'
        if (formaPago && formaPago[0]) {
          text += `• ${formaPago[0].name}\n`
          if (this.conCuantoPaga) {
            text += `• Pago con: $${this.conCuantoPaga}\n`
          }
        }

        text += '\n🚚 *FORMA DE ENTREGA:*\n'
        if (formaEnvio && formaEnvio[0]) {
          text += `• ${formaEnvio[0].name}\n`
          if (this.formaEntrega === 2 && this.clientData && this.clientData.Direccion) {
            text += `• 📍 Dirección del local: ${this.clientData.Direccion}\n`
          }
        }
        if (this.horarioDistinto && this.horaProgramada) {
          text += `• Horario programado (hoy): ${this.horaProgramada}\n`
        } else {
          text += '• Lo antes posible\n'
        }

        text += '\n✅ *Aguardo tu confirmación. ¡Gracias!*'
        const link = document.createElement('a')
        link.href = `https://api.whatsapp.com/send?phone=+549${this.clientData && this.clientData.Telefono ? this.clientData.Telefono : ''}&text=${encodeURIComponent(text)}`
        link.target = '_blank'
        link.click()
        setTimeout(() => {
          this.comprando = false
          this.$emit('pedido-grabado', response.data.message.trim())
        }, 3000)
      } else {
        this.comprando = false
        this.$emit('pedido-grabado', response.data.message.trim())
      }
    }
  },
  data () {
    return {
      formaPago: null,
      formaEntrega: null,
      usuario: null,
      observaciones: '',
      conCuantoPago: null,
      costoEnvioPorZona: null,
      porcentajeAumento: null,
      eligirConCuantoPaga: false,
      comprando: false,
      totalDescuento: 0,
      descuentos: [],
      detalleDescuentos: [],
      aplicarCupon: null,
      openCuponDialog: false,
      mpBrickOpen: false,
      mpPedidoId: null,
      mpAmount: 0,
      mpPublicKey: null,
      mpPreferenceId: null,
      mpPayerEmail: ''
    }
  },
  watch: {
    getDescuentos: {
      deep: true,
      handler: function (newVal) {
        const { descuentoTotal, hayDescuentos, detalleDescuentos } = newVal
        this.totalDescuento = descuentoTotal
        this.descuentos = hayDescuentos
        this.detalleDescuentos = detalleDescuentos || []
      }
    },
    eligirConCuantoPaga (val) {
      if (!val) {
        this.$emit('importeMinimoChange', false)
      }
    }
  }
}
</script>
<style scoped>
.checkout-resumen {
  text-align: left;
  padding: 4px 2px 8px;
}
.resumen-col {
  padding: 12px 14px;
  margin-bottom: 8px;
  background: #fafafa;
  border: 1px solid #efefef;
  border-radius: 14px;
}
.resumen-detalle {
  padding: 12px 14px;
  margin-top: 4px;
  background: #fff;
  border: 1px solid #efefef;
  border-radius: 14px;
}
.resumen-titulo {
  margin: 0 0 12px;
  font-size: 1.05rem;
  font-weight: 700;
  line-height: 1.3;
  color: rgba(0, 0, 0, 0.87);
}
.resumen-titulo--grupo {
  margin-top: 20px;
}
.resumen-item {
  display: flex;
  align-items: center;
  gap: 8px;
  min-height: 28px;
  margin-bottom: 4px;
  font-size: 0.95rem;
  color: rgba(0, 0, 0, 0.75);
}
.resumen-item--secundario {
  font-size: 0.85rem;
  color: rgba(0, 0, 0, 0.6);
  padding-left: 2px;
}
.resumen-link {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  margin: 0 0 8px 28px;
  font-size: 0.8rem;
  color: #7800C6;
  text-decoration: none;
}
.resumen-link:hover {
  text-decoration: underline;
}
.resumen-importe {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  min-height: 28px;
  margin-bottom: 4px;
  font-size: 0.95rem;
  color: rgba(0, 0, 0, 0.75);
}
.resumen-importe--descuento {
  color: #2e7d32;
  font-weight: 500;
}
.resumen-importe--total {
  margin-top: 8px;
  padding-top: 8px;
  border-top: 1px solid #e0e0e0;
  font-size: 1.05rem;
  font-weight: 700;
  color: rgba(0, 0, 0, 0.87);
}
.resumen-descuento {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 8px;
  margin: 4px 0;
  padding: 6px 8px;
  font-size: 0.8rem;
  color: #2e7d32;
  background-color: #f5f5f5;
  border-left: 3px solid #2e7d32;
  border-radius: 2px;
}
</style>
